<template>
  <div
    class="z-10 md:w-8/12 md:flex md:justify-center md:absolute md:top-video-156 md:left-video-4/12"
  >
    <div
      :style="getIsMobile ? 'height: 72vh; ' : 'height: 68vh; '"
      class="relative md:w-full"
    >
      <l-map
        :options="getMapOptions"
        @update:center="centerUpdate"
        @update:zoom="zoomUpdate"
        :style="getIsMobile ? 'height: 72vh; ' : 'height: 68vh; '"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <template v-for="(video, index) in getVideoMapView">
          <l-circle-marker
            :lat-lng="getPosition(video.contributor)"
            :options="markerOptions"
            :key="index"
          >
            <l-popup :options="popupOptions" class="">
              <MapPreviewComponent :video="video" />
            </l-popup>
          </l-circle-marker>
        </template>
      </l-map>
    </div>
  </div>
</template>

<style>
.leaflet-popup-content-wrapper {
  padding: 0px !important;
  border-radius: 0 !important;
}

.leaflet-popup-content-wrapper .leaflet-popup-content {
  margin: 0;
  padding: 0px !important;
}

.leaflet-popup-content {
  width: auto !important;
}

.grid-padding-right {
  padding-right: 17.5rem;
}
</style>

<script>
// import { latLng } from "leaflet";
import { LMap, LTileLayer, LCircleMarker, LPopup } from "vue2-leaflet";
import { mapGetters } from "vuex";

// Components
import MapPreviewComponent from "../components/MapPreviewComponent";

export default {
  name: "MapView",
  components: {
    LMap,
    LTileLayer,
    LPopup,
    LCircleMarker,
    MapPreviewComponent,
  },
  data() {
    return {
      screenWidth: 0,
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      mapOptions: {
        zoomSnap: 0.5,
        zoom: 1,
        minZoom: 1,
        // maxBounds: [
        //   [-90, -180],
        //   [90, 180]
        // ]
      },
      markerOptions: {
        radius: 10,
        color: "#61d39c",
        fillColor: "#61d39c",
        fillOpacity: "100",
      },
      popupOptions: {
        closeButton: false,
      },
    };
  },
  mounted() {
    window.addEventListener("resize", this.responsiveWindow);
    this.screenWidth = window.screen.width;
  },
  computed: {
    ...mapGetters(["getIsMobile", "getVideos"]),
    getMapOptions() {
      const options = { ...this.mapOptions };
      if (!this.getIsMobile) options.zoom = 2;
      return options;
    },
    getVideoMapView() {
      return this.getVideos;
    },
  },
  methods: {
    getPosition(contributor) {
      return [
        contributor.geolocation.latitude,
        contributor.geolocation.longitude,
      ];
    },
    responsiveWindow() {
      this.screenWidth = window.screen.width;
    },
    zoomUpdate(zoom) {},
    centerUpdate(center) {
      this.currentCenter = center;
    },
    innerClick() {
      alert("Click!");
    },
  },
};
</script>
